import { Card, CardBody, Col, Container, Row } from "reactstrap";

const DeliveryInfoPopover = ({
  projectSummary,
  isDeliveryInfoOpen,
  targetRef,
}) => {
  if (!targetRef?.current) return null;

  const plans = [
    {
      id: "express",
      name: "Express",
      days: "5",
      features: [],
      condition: "< 25K",
    },
    {
      id: "priority",
      name: "Priority",
      days: "7",
      features: [],
      condition: "Upto 1L",
    },
    {
      id: "standard",
      name: "Standard",
      days: "10",
      features: [],
      condition: "> 1L",
    },
    {
      id: "custom",
      name: "Custom",
      days: "12",
      features: [1, 2, 3, 4, 5, 6],
      condition: "> 1L",
    },
  ];

  const features = [
    "Order Size",
    "Pattern Shutters",
    "G Profile",
    "Gola Profile",
    "Light Grooves",
    "Finger Grooves",
    "CNC",
  ];

  return (
    isDeliveryInfoOpen && (
      <div
        className="position-absolute bg-white p-3 rounded-2"
        style={{
          right: "12%",
          top: "3.2rem",
          border: "1px solid #bbb",
          boxShadow: "5px 5px 10px #ccc",
          zIndex: 9,
          width: "45vw",
          color: "black",
          fontSize: "13px",
        }}
      >
        <div className="p-3 bg-EEEEEE mb-3 rounded-2">
          <div className="fs-6 mb-2">
            Your order will be delivered in{" "}
            <b>
              {projectSummary.delivery_total_days} business days
              <span className="text-capitalize">
                {" "}
                ({projectSummary.delivery_date_speed}){"."}
              </span>
            </b>
          </div>
          <div className="fs-6 text-secondary">
            Sundays and public holidays are not counted.
          </div>
        </div>
        <Container className="text-center p-0 mb-2">
          <div className="table-responsive">
            <table className="table table-bordered align-middle text-center mb-0">
              <thead>
                <tr>
                  <th
                    className="border-start-0"
                    style={{
                      borderTop: "1px solid white",
                    }}
                  />
                  {plans.map((plan) => (
                    <th key={plan.id} className="fw-normal">
                      <p className="fs-6 mb-1">{plan.name}</p>
                      <p className="fw-bold fs-6 mb-0">{plan.days} Days</p>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {features.map((feature, index) => (
                  <tr key={index}>
                    <th className="text-start px-2">{feature}</th>
                    {plans.map((plan) => (
                      <td key={plan.id}>
                        {index === 0 ? (
                          plan.condition
                        ) : plan.features.includes(index) ? (
                          <icon className="fa-solid fa-check fs-11px" />
                        ) : (
                          <span>&#10005;</span>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Container>
      </div>
    )
  );
};

export default DeliveryInfoPopover;
